import React from "react";
// mui 5
import Avatar from "@mui/material/Avatar";
// custom style
import {
  StyledCardContainer,
  StyledCardHeader,
  StyledCardContent,
} from "./styledComponents";
// custom components
import AddToCartButton from "../AddToCartButton";


function PokemonCardRecommendation({pokemon}) {
  return (
    <StyledCardContainer>
      <StyledCardHeader
        avatar={<Avatar src={pokemon.image} alt={pokemon.name} />}
        title={pokemon.name}
        subheader={`$${pokemon.price}`}
      />

      <StyledCardContent id="styled-card-content">
        <AddToCartButton pokemon={pokemon} />
      </StyledCardContent>

    </StyledCardContainer>
  );
}

export default PokemonCardRecommendation;
